/**
 * File go-back.js
 *
 * Handles the "Back" button that appears when navigating through the site
 * For the Compare page, keep track of URL changes (i.e. part removed from Compare) in order to prevent having to click
 * the "Back" button multiple times to go back to the Bearing Search page
 */
(function () {
	const originalReferrer = document.referrer;
	const initialUrl = window.location.href;
	let urlChangeCount = 0;

	/**
	 * Ensure any existing open menus are closed upon clicking the back button
	 */
	function closeMenus() {
		document.querySelectorAll('.menu-item.focus').forEach(menuItem => {
			menuItem.classList.remove('focus');
		});

		const overlay = document.querySelector('.a-overlay');
		if (overlay) {
			overlay.classList.remove('a-overlay--is-visible');
		}

		// Close hamburger menu when on mobile
		const navigationContainer = document.querySelector('.m-header__navigation-container');
		const toggleButton = document.querySelector('.m-header__menu-toggle');
		const logoContainer = document.querySelector('.m-header__logo-container');
		const searchToggleContainer = document.querySelector('.m-header__search-toggle-container');

		if (navigationContainer && navigationContainer.classList.contains('toggled')) {
			document.body.classList.remove('a-body--scroll-disable');
			navigationContainer.classList.remove('toggled');

			if (toggleButton) {
				toggleButton.setAttribute('aria-expanded', 'false');
				toggleButton.classList.remove('js-is-open');
			}

			if (logoContainer) {
				logoContainer.classList.remove('js-is-open');
			}

			if (searchToggleContainer) {
				searchToggleContainer.classList.remove('m-header__search-toggle-container--hidden');
			}
		}
	}

	/**
	 * Track URL changes on the current page
	 */
	function trackUrlChanges() {
		let lastUrl = window.location.href;

		setInterval(() => {
			const currentUrl = window.location.href;
			if (currentUrl !== lastUrl && window.location.pathname === new URL(initialUrl).pathname) {
				urlChangeCount++;
				lastUrl = currentUrl;
			}
		}, 100);
	}

	/**
	 * Handle back navigation
	 */
	function goBack() {
		closeMenus();

		if (originalReferrer.includes('my-dashboard')) {
			window.location.href = originalReferrer;
		} else if (urlChangeCount > 0) {
			history.go(-(urlChangeCount + 1));
		} else {
			history.back();
		}
	}

	/**
	 * Initialize back button and close button handlers
	 */
	document.addEventListener('DOMContentLoaded', () => {
		trackUrlChanges();

		document.querySelectorAll('.js-go-back-cta').forEach(($el) => {
			if (history.length > 1) {
				$el.addEventListener('click', goBack);
				$el.classList.remove('invisible');
			}
		});

		document.querySelectorAll('.js-close-details').forEach(($el) => {
			$el.addEventListener('click', () => {
				window.close();
				setTimeout(function(){
					window.location = $el.getAttribute('data-redirect-url');
				}, 500);
			});
		});
	});

	/**
	 * Reset counter and close menus when page is restored from cache
	 */
	window.addEventListener('pageshow', (event) => {
		if (event.persisted) {
			urlChangeCount = 0;
			closeMenus();
		}
	});
}());
